import { useEffect } from 'react';

import { RaygunErrorHandlerService } from '../services/raygun.service';

const { logError } = RaygunErrorHandlerService();

export const useChunkErrorReload = () => {
  useEffect(() => {
    const errorHandler = (event: ErrorEvent) => {
      const message = event.message?.toLowerCase() ?? '';
      const isChunkMissing = message.includes('dynamically imported');
      if (isChunkMissing) {
        logError(event.error, ['useChunkErrorReload', 'Missing chunk detected and reloaded']);
        window.location.reload();
      } else {
        logError(event.error, ['useChunkErrorReload']);
      }
    };

    window.addEventListener('error', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, []);
};
